window.closePopup = function(){
  const activePopup = document.querySelector('.popup-overlay_active');
  document.querySelector('body').classList.remove('popup-opened');

  if(activePopup){
    activePopup.classList.remove('popup-overlay_active');
  }
}

window.openPopup = function(idElement){
  closePopup();
  const block = document.getElementById(idElement);

  if(block){
    document.querySelector('body').classList.add('popup-opened');
    block.classList.add('popup-overlay_active');
  }
}

function clearErrors(form){
  const errorFields = form.querySelectorAll('.app-field_error');
  const errorForm = form.querySelector('.app-form__error-msg');
  if(errorForm) errorForm.remove();

  errorFields.forEach(function(item, i, arr) {
    if(item.querySelector('.app-field__error-wrap')) item.querySelector('.app-field__error-wrap').remove();
    item.classList.remove('app-field_error');
  });
}

function showErrors(form, errors, backEnd){
  if(backEnd){
    if(!errors.property && errors.message){
      form.appendChild(createMainError(errors.message));
    }else{
      let fieldContainer;
      let fieldEl;
      fieldEl = form.querySelector('[name="'+errors.property+'"]');
      if(!fieldEl) return false;
      fieldContainer = fieldEl.closest(".app-field");
      if(!fieldContainer)  return false;
      fieldContainer.classList.add('app-field_error');
      fieldContainer.appendChild(createErrorMessage(errors.message));
      fieldEl.addEventListener('change', hideErrorOnChange);
    }
  }else{
  let fieldContainer;
  let fieldEl;

  for (let field in errors) {
    fieldEl = form.querySelector('[name="'+field+'"]');
    if(!fieldEl) continue;
    fieldContainer = fieldEl.closest(".app-field");
    if(!fieldContainer) continue;
    fieldContainer.classList.add('app-field_error');
    fieldContainer.appendChild(createErrorMessage(errors[field]));
    fieldEl.addEventListener('change', hideErrorOnChange);
  }
  }
}

function hideErrorOnChange(e){
  let errorCont = e.target.closest(".app-field_error");
  if (errorCont){
    errorCont.querySelector('.app-field__error-wrap').remove();
    errorCont.classList.remove('app-field_error');
  }
  e.target.removeEventListener('change',hideErrorOnChange);
}

function createErrorMessage(text){
  let errorWrap = document.createElement("div");

  let errorContainer = document.createElement("div");
  let errorTextHolder = document.createElement("div");
  const errorText = document.createTextNode(text);

  errorWrap.classList.add('app-field__error-wrap');
  errorContainer.classList.add('app-field__error-msg');
  errorTextHolder.classList.add('app-field__error-msg-text');

  errorTextHolder.appendChild(errorText);
  errorWrap.appendChild(errorContainer);
  errorWrap.appendChild(errorTextHolder);

  return errorWrap;
}
function createMainError(text){
  let errorContainer = document.createElement("div");
  const errorText = document.createTextNode(text);
  errorContainer.classList.add('app-form__error-msg');
  errorContainer.appendChild(errorText);
  return errorContainer;
}

function validateOnEmptyFields(form, fields){
  let errors = {};
  const emailCheck = /\S+@\S+\.\S+/;
  let fieldItem;

  fields.forEach(function(item, i, arr) {
    //console.log(item + ': '+ form.querySelector('[name="'+item+'"]').value, form.querySelector('[name="'+item+'"]').checked);
    fieldItem = form.querySelector('[name="'+item+'"]');
    if(!fieldItem.value
      || (fieldItem.getAttribute('type') === 'checkbox' &&  !fieldItem.checked)
    ) {
      errors[item] = window.siteConfig.validationMessages.emptyField;
    } else if(fieldItem.dataset.checkEmailFormat){
      if(!emailCheck.test(fieldItem.value)) errors[item] = window.siteConfig.validationMessages.failedEmailFormat;
    } else if(fieldItem.dataset.checkEqualToField){
      let secondField = form.querySelector('[name="'+fieldItem.dataset.checkEqualToField+'"]');
      if(secondField && secondField.value && fieldItem.value !== form.querySelector('[name="'+fieldItem.dataset.checkEqualToField+'"]').value) errors[item] = window.siteConfig.validationMessages.notEqualPassword;
    }
  });

  return errors;
}
function prepareFieldsData(form, fields){
  let data = {};

  fields.forEach(function(item, i, arr) {
    data[item] = form.querySelector('[name="'+item+'"]').value;
  });

  return data;
}
async function processForm(form, fields, apiUrl){
  clearErrors(form);

  let errors = validateOnEmptyFields(form, fields);
  if (Object.keys(errors).length !== 0) {
    showErrors(form, errors);
    responseHandler(apiUrl, form, false);
  } else {
    let xhr = new XMLHttpRequest();
    xhr.open('POST', apiUrl);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function() {
      if (xhr.status === 204) {
        //console.log(xhr.responseText);
        /*const response = JSON.parse(xhr.responseText);
        if(response.success){
          if (response.redirectUrl){
            window.location = response.redirectUrl;
          }*/
          responseHandler(apiUrl, form, true);
          return true;
        /*}else{
          showErrors(form, response, true)
        }*/
      }
      else if (xhr.status === 400) {
        const response = JSON.parse(xhr.responseText);
        console.log('Failed request:' + xhr.status, xhr)
        showErrors(form, response, true)
      }
      else if (xhr.status !== 200) {
        console.log('Failed request:' + xhr.status)
      }
      responseHandler(apiUrl, form, false);
    };
    xhr.send(JSON.stringify(prepareFieldsData(form, fields)));
  }
}

function responseHandler(apiUrl, form, responseSuccess){
  const locale = window.siteConfig.localId;
  const confirmEmailLink = `/partner-admin/api/${locale}/partners/confirm-email`;

  if(apiUrl.indexOf(confirmEmailLink)===0){
    //remove get-param
    apiUrl = confirmEmailLink;
  }

  switch (apiUrl) {
    case `/partner-admin/api/${locale}/partners/reset-password`:
      if(responseSuccess){
        document.getElementById('recoveryForm').style.display = 'none';
        document.getElementById('recoveryNote').style.display = '';
      }
      break;
    case `/partner-admin/api/${locale}/sign-up`:
      if(responseSuccess){
        document.getElementById('regFormBlock').style.display = 'none';
        document.getElementById('successRegBlock').style.display = '';
        form.reset();
      }
      break;
    case `/partner-admin/api/${locale}/questions`:
      if(responseSuccess){
        document.getElementById('feedbackSendBlock').style.display = 'none';
        document.getElementById('feedbackResultBlock').style.display = '';

        form.reset();
      }
      break;
    case `/partner-admin/api/${locale}/partners/confirm-email`:
      if(responseSuccess){
        document.getElementById('sendConfirmEmailAgain').style.display = 'none';
        document.getElementById('successConfirmEmailAgain').style.display = '';

        form.reset();
      }
      break;
    case `/partner-admin/api/${locale}/partners/reset-password-confirm`:
      if(responseSuccess){
        window.location = document.getElementById('redirectToLogin').value;
      }
      break;

  }
}

async function clickRecoveryPass(e, form){
  const fields = ['email'];
  const apiUrl =`/partner-admin/api/${window.siteConfig.localId}/partners/reset-password`;
  e.preventDefault();
  processForm(form, fields, apiUrl);
}
window.clickRecoveryPass = clickRecoveryPass;

async function clickChangePass(e, form){
  const fields = ['password', 'password_repeat', 'token'];
  const apiUrl =`/partner-admin/api/${window.siteConfig.localId}/partners/reset-password-confirm`;
  e.preventDefault();
  processForm(form, fields, apiUrl);
}
window.clickChangePass = clickChangePass;

async function clickReg(e, form){
  let fields = ['name', 'email', 'localeId', 'plainPassword', 'password_repeat', 'agree'];
  fields.push(document.getElementById('contact-type-field').getAttribute('name')); // 'telegram', 'skype',
  const apiUrl =`/partner-admin/api/${window.siteConfig.localId}/sign-up`;
  e.preventDefault();
  processForm(form, fields, apiUrl);
}
window.clickReg = clickReg;

function changeContact(radio){
  let field = document.getElementById('contact-type-field');
  if(field){
    field.setAttribute('name',radio.value);
    field.setAttribute('placeholder',radio.dataset.placeholder);
  }
}
window.changeContact = changeContact;

async function sendFeedback(e, form, captchaKey){
    e.preventDefault();
    window.grecaptcha.execute(captchaKey, {action: 'submit'}).then(function(token) {
      form.querySelector('[name="captcha"]').value = token;
      const fields = ['email', 'name', 'question', 'captcha'];
      const apiUrl =`/partner-admin/api/${window.siteConfig.localId}/questions`;
      processForm(form, fields, apiUrl);
    });
}
window.sendFeedback = sendFeedback;

async function clickConfirmEmailRequest(e, form){
  const fields = ['email'];
  const emailField = form.querySelector('[name="email"]');
  const email = emailField ? emailField.value : '';
  const apiUrl =`/partner-admin/api/${window.siteConfig.localId}/partners/confirm-email/`+email;
  e.preventDefault();
  processForm(form, fields, apiUrl);
}
window.clickConfirmEmailRequest = clickConfirmEmailRequest;

function showFormForConfirmRequest(){
  const errorMessageBlock = document.getElementById('badConfirmEmailMessage');
  const formForSendRequest = document.getElementById('sendConfirmEmailAgain');

  errorMessageBlock.style.display = 'none';
  formForSendRequest.style.display = '';
}
window.showFormForConfirmRequest = showFormForConfirmRequest;

function checkHeaderState(){
  const header = document.querySelector('.app-header');

  if(!header || document.querySelector('.app-header_fixed')) return false;

  const defaultPosition = window.innerWidth < 1024 ? 0 : 15;
  if(window.scrollY < defaultPosition){
    header.style.marginTop = defaultPosition - window.scrollY + 'px';
    header.classList.remove('app-header_active');
  }else{
    header.style.marginTop = '0px';
    header.classList.add('app-header_active');
  }
}

